import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { login, coachRegisterApiGet,getTournamentGet,getSpoonseGet,getTournamentTypeGet,createTournamet} from './TournamentModel';
import Config from '../../Utility/Config';

export const getTournamentListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/tournament/list`, null);
    return getTournamentGet(response);
};

export const getSponserListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/sponser/list`, null);
    return getSpoonseGet(response);
};

export const getTournamenTypeListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/tournament-type/list`, null);
    return getTournamentTypeGet(response);
};

export const getTournamentDetailsApi = async (tournamentId) => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/tournament/read/${tournamentId}`, null);
    return getTournamentGet(response);
};
export const createTournamentApi = async (data) => {
    const response = await post(`${Config.EXTENDED_URL}admin/tournament/create`, data, null);
    return createTournamet(response);
};
